"use client";
import { styled, TextareaAutosize } from "@mui/material";
import React from "react";

interface InputProps {
  placeHolder?: string;
  value?: string | number;
  multiLineRows?: number;
  disabled?: boolean;
  onChange?: any;
}

const StyledTextArea = styled(TextareaAutosize)(() => ({
  color: "#3D465A",
  fontFamily: "var(--font-inter)",
  fontSize: "14px",
  borderRadius: "4px",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  border: "1px solid #C4C4C4",
  padding: "8px",
  "&:focus": {
    outline: 0,
    border: "1px solid rgb(151, 71, 255) !important",
    color: "#1D2330 !important",
  },
  "&[disabled]": {
    color: "#8F9295",
    backgroundColor: "#F5F5F5",
  },
  "&::placeholder": {
    color: "#646E83",
    opacity: 1,
  },
}));

export function VeTextArea({
  value,
  placeHolder,
  disabled,
  multiLineRows = undefined,
  onChange,
}: any) {
  return (
    <StyledTextArea
      minRows={multiLineRows}
      placeholder={placeHolder}
      onChange={onChange}
      disabled={disabled}
      maxRows={8}
      value={value}
    />
  );
}
